'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.helpClass = exports.lightGray = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _auth = require('../../redux/modules/auth');

var _DefaultString = require('../../helpers/DefaultString');

var _Language = require('../../helpers/Language');

var _Logs = require('../../helpers/Logs');

var _LanguageDropdown = require('./LanguageDropdown.scss');

var _LanguageDropdown2 = _interopRequireDefault(_LanguageDropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DROPDOWN_ARROW_LIGHT_GRAY = require('../../../res/images/common/dropdown_arrow_light_gray.svg');
var DROPDOWN_ARROW = require('../../../res/images/common/dropdown_arrow.svg');

var lightGray = exports.lightGray = 'light-gray';
var helpClass = exports.helpClass = 'help';

var LanguageDropdown = (_dec = (0, _reactRedux.connect)(function (state) {
  return { appInfo: state.appInfo, auth: state.auth, captcha: state.captcha, lang: state.auth.lang, log: state.log };
}, { editLanguage: _auth.editLanguage }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(LanguageDropdown, _Component);

  function LanguageDropdown() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LanguageDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LanguageDropdown.__proto__ || (0, _getPrototypeOf2.default)(LanguageDropdown)).call.apply(_ref, [this].concat(args))), _this), _this.getCaret = function () {
      return _this.props.className === lightGray ? DROPDOWN_ARROW_LIGHT_GRAY : DROPDOWN_ARROW;
    }, _this.switchMessage = function (newLang) {
      (0, _Logs.logLanguage)(_this.props.log.src, newLang, _this.props.log, _this.props.auth, _this.props.appInfo);
      if (_this.props.captcha.needCaptcha) {
        (0, _Language.updateLanguageByReload)(newLang);
      } else {
        _this.props.editLanguage(newLang, _this.props.auth.realm);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LanguageDropdown, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var caret = this.getCaret();
      var lang = this.props.lang;
      var langDropdown = _DefaultString.translations[lang || _Language.defaultLanguage].defaultMessage;
      var supportedLanguages = (0, _Language.getSupportedLanguagesByProduct)(this.props.auth.realm, this.props.auth.productName);
      return _react2.default.createElement(
        'div',
        { id: _LanguageDropdown2.default.langDropdown, className: this.props.className },
        _react2.default.createElement(
          _reactBootstrap.Dropdown,
          { pullRight: true, id: 'dropdown-lang' },
          _react2.default.createElement(
            _reactBootstrap.Dropdown.Toggle,
            { noCaret: true },
            langDropdown,
            _react2.default.createElement('img', { className: _LanguageDropdown2.default.caret, src: caret })
          ),
          _react2.default.createElement(
            _reactBootstrap.Dropdown.Menu,
            { className: 'dropdown-menu' },
            (0, _keys2.default)(supportedLanguages).map(function (language) {
              return _react2.default.createElement(
                _reactBootstrap.MenuItem,
                { key: language, eventKey: language, onClick: function onClick() {
                    return _this2.switchMessage(language);
                  }, className: lang === language ? _LanguageDropdown2.default.hidden : '' },
                _react2.default.createElement(_reactIntl.FormattedMessage, _DefaultString.translations[language])
              );
            })
          )
        )
      );
    }
  }]);
  return LanguageDropdown;
}(_react.Component), _class2.propTypes = {
  appInfo: _react.PropTypes.object,
  auth: _react.PropTypes.object,
  captcha: _react.PropTypes.object,
  className: _react.PropTypes.string,
  lang: _react.PropTypes.string,
  log: _react.PropTypes.object,
  editLanguage: _react.PropTypes.func.isRequired
}, _temp2)) || _class);
exports.default = LanguageDropdown;


//////////////////
// WEBPACK FOOTER
// ./src/components/LanguageDropdown/LanguageDropdown.js
// module id = 410
// module chunks = 0